import { defineComponent } from 'vue';
import commonFunction from '@/commons/commonFunction';

export default defineComponent({
    name: 'baseBrowserTitlePage',

    data(){
        return{
            titleCode: '', // mã màn hình
            titleRefCode: null // mã chi tiết đối tượng - dùng cho màn chi tiết
        }
    },

    mounted(){
        commonFunction.updateBrowserTitleWhenOpenScreen(this.titleCode, this.titleRefCode);
    },

    unmounted() {
        commonFunction.updateBrowserTitleWhenCloseScreen(this.titleCode, this.titleRefCode);
    },

    watch: {
        titleRefCode: function(newVal, oldVal){
            if (newVal && newVal !== oldVal){
                commonFunction.updateBrowserTitleWhenOpenScreen(this.titleCode, newVal);
            }
        }
    },
});